import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { Field } from 'react-final-form';
import { Select } from '@eika/select';
const SelectInput = _ref => {
  let {
    label,
    name,
    validate,
    values,
    onChangeOverride,
    disabled,
    overrideValueKey
  } = _ref;
  return /*#__PURE__*/React.createElement(Field, {
    name: name,
    validate: validate,
    render: _ref2 => {
      var _input$value$override;
      let {
        input,
        meta
      } = _ref2;
      return /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement(Select, {
        name: name,
        label: label,
        values: values,
        value: overrideValueKey ? (_input$value$override = input.value[overrideValueKey]) !== null && _input$value$override !== void 0 ? _input$value$override : '' : input.value,
        className: "form-control",
        onChange: event => {
          return onChangeOverride ? input.onChange(onChangeOverride(event)) : input.onChange(event);
        },
        onBlur: input.onBlur,
        error: meta.touched && meta.error ? meta.error : false,
        disabled: disabled,
        id: name
      }));
    }
  });
};
export default SelectInput;